//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniIcons from "@/components/uni-icon/uni-icon.vue"
import uniLoadMore from "components/uni-load-more/uni-load-more.vue"
import search from 'components/search/index.vue'
export default {
  data() {
    return {
      //顶部搜索对应的字段
      scenicspotIds: '', //景区id
      days: '', //几日游
      title: '', //攻略名称
      defaultSelect: '游玩日期',
      //tab栏,
      strategyList: [
        {
          code: '1',
          name: '官方攻略'
        },
        {
          code: '2',
          name: '精品游记'
        },
        {
          code: '3',
          name: '游客分享'
        },
      ],
      state: '1', //当前对应的攻略栏目（类型 字符串）1官方攻略 2精品游记 3游客分享
      //获取列表的一些参数
      page: {
        pageSize: 10,
        currentPage: 1,
        count: 0,
        loading: false,
      },
      end: false,
      count: 0,
      list: [],
      activeLine: '1', //tab下划线的位置
      schedule: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五'], //
      selectList: ['全部', '半日游', '一日游', '二日游', '三日游', '四日游', '五日游', '六日游', '七日游', '八日游', '九日游', '十日游', '十一日游', '十二日游', '十三日游', '十四日游', '十五日游'],
      urlList: {
        '1': '/weChat/cms/officialtravel/queryPage', //官方攻略
        '2': '/weChat/cms/officialstrategy/queryPage', //精品游记
        '3': '/weChat/cms/touriststrategy/queryPage' //游客分享
      }
    }
  },
  components: { uniIcons, uniLoadMore, search },
  onLoad(event) {
    this.state = event.state || '1'
    this.scenicspotIds = event.scenicspotIds
    this.days = event.days
    this.title = event.title
    this.queryData('', this.state)
  },
  onPullDownRefresh() {
    this.list = []
    this.page.currentPage = 1
    this.queryData('refresh', this.state)
  },
  onReachBottom() {
    if (this.list.length < this.count) {
      this.queryData()
    }
  },
  methods: {
    //跳转至搜索页面
    gotoSearch() {
      // uni.navigateTo({
      // 	url:`/pages/strategy/search?state=${this.state}`
      // })
    },
    nameInput(event) {
      this.title = event.target.value || ''
    },
    onConfirm(e) {
    //   console.log(e)
      let index = e.detail.value
      this.defaultSelect = this.selectList[index]
      this.days = index == 0 ? '' : index == 1 ? 0.5 : index - 1

      this.list = []
      this.page.currentPage = 1
      this.queryData('', this.state)
    },
    //tab列表选择
    active(val) {
      this.state = val
      this.list = []
      this.page.currentPage = 1
      this.queryData('', val)
      this.activeLine = val
    },
    //列表
    queryData(status, val) {
      let _this = this
      let url = val ? val : '1'
      _this.page.loading = true
      this.$ajax({
        method: 'post',
        url: _this.urlList[url],
        data: {
          ...this.page,
          scenicspotIds: this.scenicspotIds || '',
          days: this.days || '',
          title: this.title || ''
        }
      }).then(res => {
        let list = res.data.map(t => {
          return {
            ...t,
            severalDays: t.severalDays === '0.5' ? '半' : _this.schedule[(parseInt(t.severalDays)) - 1]
          }
        })
        _this.list.push.apply(_this.list, list)
        _this.page.loading = false
        _this.count = res.count
        if (_this.list.length >= _this.count) {
          _this.end = true
        }
        _this.page.currentPage += 1
        if (status === 'refresh') {
          uni.stopPullDownRefresh();
        }
      })
    }
  },
}
